import type { SxProps, Theme } from "@mui/material";

const itemStyle: SxProps<Theme> = {
  position: "relative",
  borderBottom: "1px solid #e4e4e4",
  borderTop: "1px solid transparent",
  borderLeft: "4px solid transparent",
  borderRight: "4px solid transparent",
  paddingTop: 1,
  paddingBottom: 0.8,
  px: 1,
  transition: "border-color .1s ease",
};

export const itemActiveStyle: SxProps<Theme> = {
  position: "relative",
  zIndex: 1,
  borderLeftColor: "#50afff",
  borderRightColor: "#50afff",
};

export const itemReadyToWorkStyle: SxProps<Theme> = {
  ...itemStyle,
};

export const itemNotReadyToWorkStyle: SxProps<Theme> = {
  ...itemStyle,
  color: "#a9a7a7",
};

export const itemOverlayStyle: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  background: "rgba(124, 224, 255, 0.1)",
  zIndex: 100,
};

export const indexRowStyle: SxProps = {
  pr: 2,
};

export const nameRowStyle: SxProps = {
  display: "flex",
  alignItems: "bottom",
  pb: 0.2,
  fontSize: 12,
  color: "#a9a7a7",
};

export const nameRowTitleStyle: SxProps = {
  // pl: 1,
};

export const itemContentStyle: SxProps = {
  display: "flex",
};

export const originalRowStyle: SxProps = {
  flex: 1,
};

export const gapRowStyle: SxProps = {
  width: 25,
};

export const editorRowStyle: SxProps = {
  flex: 1,

  "& .macro": {
    cursor: "default",
  },
};

export const validationRowStyle: SxProps = {
  display: "flex",
  width: 40,
  alignItems: "flex-start",
  justifyContent: "left",
};

export const approveRowStyle: SxProps = {
  display: "flex",
  width: 30,
  alignItems: "flex-start",
  justifyContent: "center",
  whiteSpace: "nowrap",
};

// ApproveStatus
export const approveStatusStyle: SxProps = {
  color: "var(--status-color--not-approved)",

  "&:hover": {
    color: "var(--status-color--success)",
  },
};

export const approveDisabledStyle: SxProps = {
  pt: 1,
  px: "8px",
  opacity: 0.3,
};
